import React, { useState } from "react";
import AdminSidebar from "./AdminSidebar";
import AdminTopBar from "./AdminTopBar";
import { useNavigate } from "react-router-dom";
import api from "./api/axios";
import { useActivityLogger } from "./hooks/useActivity";
export default function AdminAddUser() {
  const navigate = useNavigate();

  const [namaKtp, setNamaKtp] = useState("");
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [nomorHp, setNomorHp] = useState("");
  const [password, setPassword] = useState("");
  const { logAdminActivity } = useActivityLogger();
  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);

  const generateNik = () => {
    let nik = "";
    for (let i = 0; i < 16; i++) {
      nik += Math.floor(Math.random() * 10);
    }
    return nik;
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 5 * 1024 * 1024) {
        alert(
          "Ukuran gambar melebihi 4MB. Silakan unggah gambar yang lebih kecil."
        );
        e.target.value = null; // Reset input file
        return;
      }

      // Validasi tipe file
      const allowedTypes = [
        "image/jpeg",
        "image/png",
        "image/jpg",
        "image/gif",
      ];
      if (!allowedTypes.includes(file.type)) {
        alert(
          "Format file tidak didukung. Silakan gunakan format JPG, PNG, atau GIF."
        );
        e.target.value = null;
        return;
      }

      setImageFile(file);
      setImagePreview(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const nik = generateNik();
    // Pastikan nomor HP diisi jika menggunakan endpoint /register

    const formData = new FormData();
    formData.append("email", email);
    formData.append("nama_ktp", namaKtp);
    formData.append("password", password);
    formData.append("role", "admin");
    formData.append("username", username);
    formData.append("nik", nik);
    formData.append("nomor_hp", nomorHp);
    formData.append("nama_samaran", username);
    if (imageFile) {
      formData.append("image", imageFile);
    }
    // formData.append
    try {
      await api.post("/admins", formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });
      alert(`Admin dengan username ${username} berhasil dibuat`);
      // Log activity
      logAdminActivity(
        "create",
        "create_admin_user",
        "user",
        nik,
        username,
        "success",
        "",
        `Admin baru dibuat dengan NIK: ${nik}`
      );
      navigate("/admin/adminlist");
    } catch (error) {
      console.error("Error creating admin:", error);

      let errorMessage = "Pembuatan Admin baru gagal dilakukan";

      if (error.response?.data?.error) {
        const apiError = error.response.data.error;
        if (apiError === "username already exists") {
          errorMessage =
            "Username sudah terdaftar. Silakan gunakan username lain.";
        } else if (apiError === "email already exists") {
          errorMessage = "Email sudah terdaftar. Silakan gunakan email lain.";
        } else if (apiError === "invalid request body") {
          errorMessage =
            "Data yang dimasukkan tidak valid. Periksa kembali form.";
        } else {
          errorMessage = `Pembuatan Admin gagal: ${apiError}`;
        }
      } else if (error.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error.response?.status === 400) {
        errorMessage =
          "Data tidak valid. Periksa kembali informasi yang dimasukkan.";
      } else if (error.response?.status === 403) {
        errorMessage = "Anda tidak memiliki izin untuk membuat admin.";
      } else if (error.response?.status >= 500) {
        errorMessage = "Server sedang bermasalah. Silakan coba lagi nanti.";
      } else if (!error.response) {
        errorMessage =
          "Tidak dapat terhubung ke server. Periksa koneksi internet.";
      }

      alert(errorMessage);
    }
  };

  return (
    <div className="min-h-screen flex">
      <AdminSidebar />
      <div className="flex-1 p-6 bg-gray-50">
        <AdminTopBar />

        <div className="bg-white p-6 rounded shadow">
          <button
            onClick={() => navigate(-1)}
            className="text-xl text-black font-semibold mb-8"
          >
            &lt; Buat Admin
          </button>

          <form onSubmit={handleSubmit} className="grid grid-cols-1 gap-4">
            <div>
              <label className="text-sm block mb-1">Nama</label>
              <input
                type="text"
                placeholder="Nama"
                className="w-full border rounded px-3 py-2 text-sm"
                value={namaKtp}
                onChange={(e) => setNamaKtp(e.target.value)}
                required
              />
            </div>
            <div>
              <label className="text-sm block mb-1">Username</label>
              <input
                type="text"
                placeholder="Username"
                className="w-full border rounded px-3 py-2 text-sm"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
            </div>
            <div>
              <label className="text-sm block mb-1">E-mail</label>
              <input
                type="email"
                placeholder="E-mail"
                className="w-full border rounded px-3 py-2 text-sm"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div>
              <label className="text-sm block mb-1">No. HP</label>
              <input
                type="text"
                placeholder="No. HP"
                className="w-full border rounded px-3 py-2 text-sm"
                value={nomorHp}
                onChange={(e) => setNomorHp(e.target.value)}
                required
              />
            </div>
            <div>
              <label className="text-sm block mb-1">Password</label>
              <input
                type="password"
                placeholder="Password"
                className="w-full border rounded px-3 py-2 text-sm"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            <div>
              <label className="text-sm block mb-1">
                Upload Gambar Profil (opsional, max file size 4 MB)
              </label>
              <input
                type="file"
                accept="image/*"
                onChange={handleFileChange}
                className="w-full text-sm mb-2"
              />
              {imagePreview && (
                <div className="mt-2">
                  <img
                    src={imagePreview}
                    alt="Preview"
                    className="max-h-40 rounded border"
                  />
                </div>
              )}
            </div>

            <div className="flex justify-end">
              <button
                type="submit"
                className="bg-blue-500 text-white px-6 py-2 rounded hover:bg-blue-600"
              >
                Simpan
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
